export const FORENSIC_PLAIN_FALLBACK =
    "There isn't enough data yet to calculate this reliably for this company.";

const JARGON_LOOKUP = {
    DSRI: 'Days Sales Receivable Index: whether customers are taking longer to pay than last year.',
    DSO: 'Days Sales Outstanding: how many days, on average, customers take to pay.',
    DSI: 'Days Sales of Inventory: how many days of stock the company is holding.',
    TATA: 'Total Accruals to Total Assets: how much reported profit is not yet cash, relative to company size.',
    LVGI: 'Leverage Index: whether the company is using more debt than last year.',
    GMI: 'Gross Margin Index: whether the profit left after making the product shrank versus last year.',
    AQI: 'Asset Quality Index: whether a larger share of assets is harder to turn into cash than last year.',
    SGAI: 'Sales, General & Admin Index: whether overhead costs grew faster than sales.',
    DEPI: 'Depreciation Index: whether assets are being written down more slowly than last year.',
    SGI: 'Sales Growth Index: whether sales grew versus last year.',
    'NI − CFO': 'The gap between reported profit and cash from running the business.',
    'NI - CFO': 'The gap between reported profit and cash from running the business.',
    'NI-CFO': 'The gap between reported profit and cash from running the business.',
    CFO: 'Cash from operations: cash the business actually collected from running itself.',
    accruals: 'Accounting entries that count as profit before the cash has actually arrived.',
    Accruals: 'Accounting entries that count as profit before the cash has actually arrived.',
    'Z″': "Altman's distress score on this dashboard: a balance-sheet check of whether the company can pay its bills.",
    'Z"': "Altman's distress score on this dashboard: a balance-sheet check of whether the company can pay its bills.",
    "Z''": "Altman's distress score on this dashboard: a balance-sheet check of whether the company can pay its bills.",
    'Z-Score': "Altman's distress score on this dashboard: a balance-sheet check of whether the company can pay its bills.",
    'M-Score': 'A statistical check for whether reported profits look artificially inflated.',
    'C-Score': 'A count of six common accounting warning signs.',
    'F-Score': 'A nine-point checklist of basic financial health.',
    'grey zone': 'A middle band that is neither clearly safe nor clearly flagged.',
    'gray zone': 'A middle band that is neither clearly safe nor clearly flagged.',
};

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const TERM_KEYS = Object.keys(JARGON_LOOKUP).sort((a, b) => b.length - a.length);

const TERM_PATTERN = new RegExp(`(${TERM_KEYS.map(escapeRegExp).join('|')})`, 'gi');

const definitionFor = (matched) => {
    if (JARGON_LOOKUP[matched]) return JARGON_LOOKUP[matched];
    const lower = matched.toLowerCase();
    const key = TERM_KEYS.find((term) => term.toLowerCase() === lower);
    return key ? JARGON_LOOKUP[key] : null;
};

export const splitForensicJargon = (text) => {
    if (!text) return [];
    const source = String(text);
    const parts = [];
    let lastIndex = 0;
    TERM_PATTERN.lastIndex = 0;
    let match = TERM_PATTERN.exec(source);
    while (match) {
        if (match.index > lastIndex) {
            parts.push({ text: source.slice(lastIndex, match.index) });
        }
        const matched = match[0];
        const definition = definitionFor(matched);
        parts.push(definition ? { text: matched, definition } : { text: matched });
        lastIndex = match.index + matched.length;
        match = TERM_PATTERN.exec(source);
    }
    if (lastIndex < source.length) {
        parts.push({ text: source.slice(lastIndex) });
    }
    return parts.length ? parts : [{ text: source }];
};
